var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowornaments(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 85,
    height: 87,
    viewBox: "0 0 85 87",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.14359 44L17 20L30.8564 44H3.14359Z",
    fill: "#FF9FD3",
    stroke: "#FF9FD3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36.951 12.0475L78.2969 0.71123L67.2183 43.0187L66.0849 41.8589L76.1085 3.58035L76.3279 2.74246L75.4926 2.97148L38.1004 13.2237L36.951 12.0475ZM41.1932 16.3884L70.9491 8.22992L62.976 38.6778L41.1932 16.3884Z",
    fill: "#FF9FD3",
    stroke: "#FF9FD3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M71.1821 78.6909L61.4273 68.9362L74.7525 65.3657L71.1821 78.6909Z",
    fill: "#FF9FD3",
    stroke: "#FF9FD3",
    strokeWidth: 5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowornaments);
export default __webpack_public_path__ + "static/media/arrowornaments.bd0aba5f51fb8aa61903085ac030ae07.svg";
export { ForwardRef as ReactComponent };